import '../css/app.css'

import './parts/commerce';

import { initPaymentErrorMonitor } from './payment-error-monitor.js';

initPaymentErrorMonitor();

import $ from 'jquery'
window.$ = window.jQuery = $

import Alpine from 'alpinejs'

window.Alpine = Alpine
Alpine.start()

import 'lazysizes';
import 'lazysizes/plugins/parent-fit/ls.parent-fit';
import 'lazysizes/plugins/object-fit/ls.object-fit.min.js';

lazySizes.init();

import AOS from 'aos'
import 'aos/dist/aos.css'

AOS.init({
  duration: 800,
  once: true,
})

//import AOS from 'aos';

//https://github.com/michalsnik/aos/tree/v2#-animations
//AOS.init();
//document
//  .querySelectorAll('img')
//  .forEach((img) => img.addEventListener('load', () => AOS.refresh()));

import { Fancybox } from '@fancyapps/ui'


Fancybox.bind('[data-fancybox="images"]', {
  //
})

import Headroom from 'headroom.js'

var header = document.querySelector('#main-nav')
var headroomOptions = {
  offset: 0,
  tolerance: {
    up: 0,
    down: 0,
  },
  classes: {
    initial: 'header--fixed',
    pinned: 'slideDown',
    unpinned: 'slideUp',
    top: 'top',
    notTop: 'not-top',
  },
}

// construct an instance of Headroom, passing the element
var headroom = new Headroom(header, headroomOptions)
// initialise
headroom.init()

import Splide from '@splidejs/splide'

new Splide('#announcement', {
  type: 'loop',
  perPage: 1,
  autoplay: true,
  pagination: false,
  arrows: false,
}).mount();


// Accept HMR as per: https://vitejs.dev/guide/api-hmr.html
if (import.meta.hot) {
  import.meta.hot.accept(() => {
    console.log('HMR')
  })
}
